import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExerciseActivityTypeEnum, ExerciseTemplateDto } from '@therapist/shared/models/exercise/exercise-template.dto';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Textarea } from 'primeng/textarea';
import { InputNumber } from 'primeng/inputnumber';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { RepetitionUnitTypeEnum } from '@therapist/shared/models/exercise/repetition-unit-type.enum';
import { Select } from 'primeng/select';
import { ExerciseActivityBadgeComponent } from '../exercise-activity-badge/exercise-activity-badge.component';
import { JointBadgeComponent } from '../joint-badge/joint-badge.component';

// ToDo: merge ist with exercise-template-edit-list-wrapper
@Component({
  selector: 'sana-tp-exercise-template-edit-list-entry-item',
  imports: [
    Textarea,
    InputNumber,
    ReactiveFormsModule,
    Button,
    Tooltip,
    Select,
    ExerciseActivityBadgeComponent,
    JointBadgeComponent
  ],
  templateUrl: './exercise-template-edit-list-entry-item.component.html',
  styleUrl: './exercise-template-edit-list-entry-item.component.scss'
})
export class ExerciseTemplateEditListEntryItemComponent {

  @Input({ required: true }) exercise!: ExerciseTemplateDto;
  @Input({ required: true }) listIdx!: number;
  @Input({ required: true }) exerciseFormArray!: FormArray;
  @Input() isReadonly: boolean = false;

  @Output() removeExercise = new EventEmitter<string>();

  getFormControlForExercise(ctrlName: 'numberOfSets' | 'numberOfRepetitions' | 'customInstructions', index: number): FormControl {
    return this.exerciseFormArray.at(index).get(ctrlName) as FormControl;
  }

  protected readonly ExerciseActivityTypeEnum = ExerciseActivityTypeEnum;
  protected readonly RepetitionUnitTypeEnum = RepetitionUnitTypeEnum;
}
